import { AxiosResponse } from "axios";
import { adminAxiosInstance } from "./instances";
import { ENDPOINTS } from "./endpoints";
import { IProjectConfigurationResponseData } from "../../redux/reducers/ui/uiTypes";

export const getCurrentStageAPI = async (
  stageId: number
): Promise<AxiosResponse<any>> => {
  return await adminAxiosInstance.get(
    `${ENDPOINTS.STAGES.RETRIEVE_STAGE}/${stageId}`
  );
};

export const getCurrentAdminStageAPI = async ({
  organizationId,
  stageId,
}: {
  organizationId: number;
  stageId: number;
}): Promise<AxiosResponse<IProjectConfigurationResponseData>> => {
  return await adminAxiosInstance.get(
    `${ENDPOINTS.STAGES.ADMIN_STAGE}/${stageId}?organizationId=${organizationId}`
  );
};
